import React,{useRef} from 'react';
import {Input} from '../controls/controls.jsx';
import {Field} from '../display/display.jsx';
import './account-blocks.css';
/* Account blocks (UX plan D4c, 5 Nov 2026). */

/** One real one-time-code input; reaching `length` digits calls onComplete once per distinct code. */
export function CodeEntry({label='6 haneli kod',value,onValueChange,onComplete,length=6,disabled=false,autoFocus=true}){
 const last=useRef('');
 const change=event=>{
  const next=event.target.value.replace(/\D/g,'').slice(0,length);onValueChange?.(next);
  if(next.length===length&&next!==last.current&&!disabled){last.current=next;onComplete?.(next);}
  if(next.length<length)last.current='';
 };
 return <Field label={label}><Input className="bs-code-entry" value={value} onChange={change} required inputMode="numeric" autoComplete="one-time-code" pattern={`[0-9]{${length}}`} maxLength={length} autoFocus={autoFocus} disabled={disabled}/></Field>;
}
